/**
 * Polls the site's /about/ endpoint until the backend reports
 * settings_deployed, or the attempt budget runs out.
 *
 * deploy_next returns 200 when the sync task is *queued* (django-q), not when
 * the deploy has happened — settings_deployed only flips once the worker has
 * generated and uploaded the settings (typically ~15s). Callers should treat
 * `deployed: false` as "not confirmed", not as a hard failure: the deploy may
 * still land after the budget.
 */
export interface WaitForSettingsDeployedResult {
  deployed: boolean;
  siteInfo?: any;
}

export const waitForSettingsDeployed = async (
  AxiosUI: { get: (url: string) => Promise<{ data: any }> },
  siteId: string,
  maxAttempts = 18,
  intervalMs = 5000
): Promise<WaitForSettingsDeployedResult> => {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    if (attempt > 0) {
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
    try {
      const response = await AxiosUI.get(`customer/${siteId}/about/`);
      if (response.data?.settings_deployed) {
        return { deployed: true, siteInfo: response.data };
      }
    } catch {
      // Transient poll failure — keep polling; terminal errors surface via the
      // caller's own requests afterwards.
    }
  }
  return { deployed: false };
};
